<template>
  <div class="initial-profile-parent">
    <div
      class="initial-profile-picture"
    >
      <img :src="profile.avatarfull">
      <div
        class="overlay"
        @click="removeProfile"
      >
        <div class="text">
          <span class="icon is-small is-left">
            <i class="fas fa-times" />
          </span>
        </div>
      </div>
    </div>
    <div id="details">
      <div id="vanity">
        <a
          :href="profile.profileurl"
          target="_blank"
        >{{ profile.personaname }}</a>
      </div>
      <div id="count">
        games owned:
        {{ profile.game_count }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {};
  },
  methods: {
    removeProfile: function() {
      this.$emit("removeProfile", this.profile);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 640px) {
  .avatar img {
    height: 120px;
    height: 120px;
  }
}
.initial-profile-picture {
  display: flex;
}

.initial-profile-parent {
  display: flex;
  flex-direction: row;
}

.initial-profile-picture:hover .overlay {
  opacity: 1;
  cursor: pointer;
}
.text {
  font-size: 80px;
  text-align: center;
  line-height: 204px;
  opacity: 0.5;
}

.initial-profile-parent img {
  display: block;
}

.overlay {
  position: absolute;
  width: 184px;
  height: 184px;
  opacity: 0;
  transition: 0.5s ease;
  background-color: white;
}

#details {
  margin-left: 1em;
}
#vanity {
  font-size: 1.5em;
}
#count {
  color: grey;
}
a:link,
a:visited {
  color: black;
}
a:hover {
  color: #3273dc;
}
</style>